import { IconNameT } from '@cad-arc';
import { globalAttributes, AgencyTypeGlobal } from '../../common/global-attributes';

export const agencyTypeDisplayNames: Record<AgencyTypeGlobal, string> = {
    [globalAttributes.agencyTypeGlobal.POLICE]: 'Police',
    [globalAttributes.agencyTypeGlobal.FIRE]: 'Fire',
    [globalAttributes.agencyTypeGlobal.EMS]: 'EMS',
};

export const agencyTypeIconNames: Record<AgencyTypeGlobal, IconNameT> = {
    [globalAttributes.agencyTypeGlobal.POLICE]: 'Police',
    [globalAttributes.agencyTypeGlobal.FIRE]: 'Fire',
    [globalAttributes.agencyTypeGlobal.EMS]: 'EMS',
};
